// An event's time text in its colour (RULES.timeLabel; shared/cases/time-label.json): green "Now · until 9pm", a blue
// countdown "in 26 min", else "at 8pm". Moves on with the clock.
import type { FeedEvent } from "../data/event";
import { RULES } from "../shared/rules";
import { useNow } from "../state/clock";

export function TimeText({ event, as: Tag = "span", className }: { event: FeedEvent; as?: "span" | "b" | "div"; className?: string }) {
  const { text, tone } = RULES.timeLabel(event, useNow());
  return <Tag className={[className, `tone-${tone}`].filter(Boolean).join(" ")}>{text}</Tag>;
}
